export default "__VITE_ASSET__$8MQ0Yai__"